import React from 'react';
import { Link } from 'gatsby';
import { motion } from 'framer-motion';

import { GridCardProps } from './GridCardProps';

import * as styles from './GridCard.module.scss';

export const GridCard: React.FC<GridCardProps> = ({
	image,
	title,
	description,
	slug,
}) => {
	return (
		<Link to={slug}>
			<motion.div
				whileHover={{
					scale: 1.02,
					y: -10,
				}}
				className={styles.root}
			>
				<div className={styles.image}>
					<img src={image} />
				</div>
				<div className={styles.content}>
					<p className="font-size-md font-600">{title}</p>
					<hr />
					<p className="font-size-sm line-height-sm mt-2">{description}</p>
					<Link className="bttn bttn-orange-border link mt-3" to={slug}>
						See more
					</Link>
				</div>
			</motion.div>
		</Link>
	);
};
